import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import TravelHeader from "./sections/TravelHeader";
import HandpanInteractiveNavigationHub from "./sections/HandpanInteractiveNavigationHub";
import ATasteOfItaly from "./sections/ATasteOfItaly";
import LocallySourcedDailySmashed from "./sections/LocallySourcedDailySmashed";
import EyeHealthEssentials from "./sections/EyeHealthEssentials";
import ClientSuccessStories from "./sections/ClientSuccessStories";
import VisualPoetry from "./sections/VisualPoetry";
import ImagerySection from "./sections/ImagerySection";
import ContactCallToAction from "./sections/ContactCallToAction";
import DonationMemorial from "./sections/DonationMemorial";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <TravelHeader />
      <ATasteOfItaly />
      <LocallySourcedDailySmashed />
      <EyeHealthEssentials />
      <ClientSuccessStories />
      <VisualPoetry />
      <ImagerySection />
      <ContactCallToAction />
      <HandpanInteractiveNavigationHub />
      <DonationMemorial />
      <Footer />
    </div>;
}